import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isAgreementChecked:false,
    isPolicyChecked:false,
    isConfidentialInfoChecked:false
}
export const termsConditionsSlice = createSlice({
    name: 'termsConditions',
    initialState,
    reducers: {
        setIsAgreementChecked: (state, action) => {
            state.isAgreementChecked = action.payload.isChecked;
        },
        setIsPolicyChecked: (state, action) => {
            state.isPolicyChecked = action.payload.isChecked;
        },
        removeAllCheck:(state,action)=>{
            state.isAgreementChecked=false;
            state.isPolicyChecked=false;
            state.isConfidentialInfoChecked=false
        },
        setIsConfidentialInfoChecked: (state, action) => {
            state.isConfidentialInfoChecked = action.payload.isChecked;
        },
    }
})

export const { setIsAgreementChecked, setIsPolicyChecked, removeAllCheck, setIsConfidentialInfoChecked } = termsConditionsSlice.actions
export default termsConditionsSlice.reducer